var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h900v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.448 274.58c16.342 0 8.696-25.942-12.009-19.746-1.146-36.02-59.797-62.375-84.05-13.792-6.857-5.432-22.254 4.828-18.844 13.792-7.617.65-13.609 1.532-18.271 2.7-10.765 2.698-8.634 16.924 2.462 16.825l130.712.221z",
    fill: "#fff",
    stroke: "#7c5f5f",
    strokeWidth: 11
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.897 183.52h65.558c5.861 0 8.387-7.651 3.59-11.044a7.406 7.406 0 0 0-.203-.144c-6.829-4.732-15.792-4.302-15.792-4.302s-1.279-25.603-25.393-25.603c-21.802 0-30.496 21.572-33.632 33.457-1.019 3.861 1.909 7.636 5.872 7.636z",
    fill: "#fff",
    stroke: "#7c5f5f",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.905 180.085h44.018c3.936 0 5.631-5.17 2.411-7.462a6.78 6.78 0 0 0-.137-.098c-4.585-3.197-10.603-2.907-10.603-2.907s-.859-17.299-17.05-17.299c-14.638 0-20.476 14.576-22.581 22.606-.684 2.609 1.281 5.16 3.942 5.16zm-51.457-54.696h-44.954c-4.02 0-5.751-5.169-2.462-7.462.046-.033.092-.066.139-.097 4.683-3.198 10.829-2.907 10.829-2.907s.877-17.3 17.413-17.3c14.949 0 20.911 14.576 23.061 22.607.699 2.609-1.309 5.159-4.026 5.159zm-47.122 72.348h44.954c4.019 0 5.751-5.376 2.462-7.761a7.116 7.116 0 0 0-.14-.101c-4.683-3.325-10.828-3.023-10.828-3.023s-.878-17.992-17.413-17.992c-14.95 0-20.912 15.159-23.062 23.511-.698 2.713 1.309 5.366 4.027 5.366zm202.314-86.675h-86.565c-7.008 0-10.031-8.892-4.294-12.837l.243-.166c8.167-5.5 18.886-5 18.886-5s1.531-29.754 30.369-29.754c14.257 0 25.78 23.878 25.78 23.878s19.395 0 22.605 15.003c.97 4.545-2.283 8.876-7.024 8.876zm267.981 76.9c12.054 0 6.414-19.189-8.857-14.606-.846-26.644-44.106-46.139-61.994-10.202-5.057-4.018-16.414 3.571-13.899 10.202-5.618.481-10.038 1.134-13.476 1.998-7.94 1.995-6.368 12.518 1.815 12.445l96.411.163zm148.281-4.202h65.558c5.862 0 8.387-7.65 3.591-11.044-.067-.048-.135-.097-.203-.144-6.83-4.732-15.792-4.302-15.792-4.302s-1.28-25.603-25.394-25.603c-21.802 0-30.496 21.572-33.632 33.457-1.018 3.861 1.909 7.636 5.872 7.636zm-190.99-74.652h44.017c3.936 0 5.631-5.17 2.411-7.463l-.136-.097c-4.586-3.197-10.604-2.907-10.604-2.907s-.859-17.299-17.05-17.299c-14.638 0-20.475 14.576-22.581 22.606-.684 2.609 1.282 5.16 3.943 5.16zm117.255 43.314h-44.954c-4.019 0-5.751-5.169-2.462-7.462.046-.033.092-.066.139-.097 4.683-3.198 10.829-2.907 10.829-2.907s.877-17.3 17.413-17.3c14.95 0 20.911 14.576 23.062 22.607.698 2.609-1.309 5.159-4.027 5.159zM396.253 92.181h44.954c4.02 0 5.751-5.376 2.462-7.76a5.178 5.178 0 0 0-.139-.102c-4.683-3.325-10.829-3.023-10.829-3.023s-.877-17.991-17.412-17.991c-14.95 0-20.912 15.159-23.062 23.51-.699 2.713 1.309 5.366 4.026 5.366zm347.097 11.373h-86.565c-7.008 0-10.031-8.891-4.294-12.836.08-.055.162-.112.243-.166 8.167-5.5 18.886-5.001 18.886-5.001s1.531-29.754 30.369-29.754c14.257 0 25.78 23.879 25.78 23.879s19.395 0 22.605 15.003c.97 4.545-2.283 8.875-7.024 8.875z",
    fill: "#fff",
    stroke: "#7c5f5f",
    strokeWidth: 11
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M178.427 415.24 90.092 552.21H271.53l-88.335-136.97c-.377-.584-1.197-1.102-2.385-1.102-1.188 0-2.007.518-2.384 1.102zm421.179-24.021L493.461 552.21h219.803L607.119 391.219c-.652-.989-1.995-1.748-3.756-1.748-1.762 0-3.105.759-3.757 1.748z",
    fill: "#fff",
    stroke: "#7c5f5f",
    strokeWidth: 11
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M308.254 354.592 178.148 552.21h271.298L319.341 354.592c-1.052-1.597-3.09-2.657-5.544-2.657-2.454 0-4.492 1.06-5.543 2.657zm387.874 42.656L589.982 558.239h219.804L703.641 397.248c-.653-.989-1.995-1.748-3.757-1.748s-3.104.759-3.756 1.748z",
    fill: "#fff",
    stroke: "#7c5f5f",
    strokeWidth: 11
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m313.797 527.647 27.941 18.038 27.587-18.038-27.587-69.676-27.941 69.676z",
    fill: "#fff",
    stroke: "#7c5f5f",
    strokeWidth: 11
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7c5f5f",
    strokeWidth: 11,
    d: "M345.47 509.609v48.101m-18.573-40.551 17.335 12.383"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m388.87 527.647 27.941 18.038 27.587-18.038-27.587-69.676-27.941 69.676z",
    fill: "#fff",
    stroke: "#7c5f5f",
    strokeWidth: 11
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7c5f5f",
    strokeWidth: 11,
    d: "M420.542 509.609v48.101m-18.573-40.551 17.335 12.383"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m463.942 520.55 34.537 22.296 34.101-22.296-34.101-86.125-34.537 86.125z",
    fill: "#fff",
    stroke: "#7c5f5f",
    strokeWidth: 11
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7c5f5f",
    strokeWidth: 11,
    d: "M501.793 498.254v59.457m-22.413-49.068 21.427 15.306"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M654.713 160.203c-9.777 42.649-56.035 69.318-104.166 58.285-48.132-11.033-78.155-55.188-68.379-97.837 9.776-42.65 56.034-69.318 104.166-58.285 48.132 11.033 78.155 55.187 68.379 97.837z",
    fill: "#fff",
    stroke: "#7c5f5f",
    strokeWidth: 11
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M764.175 265.565c-2.512 10.959-10.697 20.678-24.608 28.656-13.918 7.983-33.079 13.912-56.342 17.364-46.491 6.9-108.192 3.738-173.972-11.341-65.781-15.079-122.699-39.107-161.542-65.568-19.437-13.24-34.103-26.923-43.154-40.171-9.047-13.241-12.181-25.555-9.669-36.513 2.512-10.959 10.697-20.678 24.607-28.656 13.918-7.982 33.079-13.912 56.343-17.364 46.491-6.9 108.191-3.737 173.972 11.341 65.781 15.079 122.698 39.107 161.542 65.568 19.437 13.241 34.102 26.924 43.154 40.171 9.046 13.241 12.181 25.555 9.669 36.513z",
    fill: "#fff",
    stroke: "#7c5f5f",
    strokeWidth: 11
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 408.929,
    cy: 148.129,
    rx: 32.784,
    ry: 13.951,
    transform: "rotate(3.397 408.929 148.129)",
    fill: "#E1E4E5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 500.304,
    cy: 159.289,
    rx: 32.784,
    ry: 13.951,
    transform: "rotate(9.407 500.304 159.289)",
    fill: "#E1E4E5"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 594.296,
    cy: 187.19,
    rx: 32.784,
    ry: 13.951,
    transform: "rotate(22.373 594.296 187.19)",
    fill: "#E1E4E5"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 520.684,
    cy: 235.034,
    rx: 86.001,
    ry: 36.596,
    transform: "rotate(14.024 520.684 235.034)",
    fill: "#7c5f5f"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 688.16,
    cy: 234.623,
    rx: 32.784,
    ry: 13.951,
    transform: "rotate(33.15 688.16 234.623)",
    fill: "#E1E4E5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m236.34 558.427 202.398-347.924c106.642-11.156 153.776 28.355 164.012 49.504l-41.178 298.42H236.34z",
    fill: "#f4f2b6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M405.479 435.978h6.937v12.187h-6.937v14.485h-15.797v-14.485h-26.391l-.937-9.656 27.328-43.969v-.14h15.797v41.578zm-28.079 0h12.282v-21l-.985 1.594-11.297 19.406zm89.344-1.219c0 9.219-2.078 16.328-6.234 21.328-4.125 5-9.953 7.5-17.485 7.5-7.593 0-13.468-2.515-17.625-7.547-4.156-5.031-6.234-12.125-6.234-21.281V422.29c0-9.218 2.063-16.328 6.188-21.328 4.156-5 10.015-7.5 17.578-7.5 7.562 0 13.422 2.516 17.578 7.547 4.156 5.031 6.234 12.141 6.234 21.328v12.422zm-15.797-14.484c0-4.907-.64-8.563-1.922-10.969-1.281-2.438-3.312-3.656-6.093-3.656-2.719 0-4.703 1.125-5.953 3.375-1.219 2.25-1.875 5.656-1.969 10.218v17.438c0 5.094.64 8.828 1.922 11.203 1.281 2.344 3.312 3.516 6.093 3.516 2.688 0 4.672-1.141 5.954-3.422 1.281-2.313 1.937-5.922 1.968-10.828v-16.875zm65.719 15.703h6.938v12.187h-6.938v14.485h-15.797v-14.485h-26.39l-.938-9.656 27.328-43.969v-.14h15.797v41.578zm-28.078 0h12.281v-21l-.984 1.594-11.297 19.406z",
    fill: "#000000"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.44 548.412v-14.296 14.296z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M140.44 548.412v-14.296",
    stroke: "#7c5f5f",
    strokeWidth: 4
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.835 548.412v-9.897 9.897z",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M155.835 548.412v-9.897",
    stroke: "#7c5f5f",
    strokeWidth: 4
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.043 548.412v-9.897 9.897z",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M125.043 548.412v-9.897",
    stroke: "#7c5f5f",
    strokeWidth: 4
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.512 548.412v-14.296 14.296z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M215.512 548.412v-14.296",
    stroke: "#7c5f5f",
    strokeWidth: 4
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.908 548.412v-9.897 9.897z",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M230.908 548.412v-9.897",
    stroke: "#7c5f5f",
    strokeWidth: 4
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.116 548.412v-9.897 9.897z",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M200.116 548.412v-9.897",
    stroke: "#7c5f5f",
    strokeWidth: 4
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M671.309 553.296V539v14.296z",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M671.309 553.296V539",
    stroke: "#7c5f5f",
    strokeWidth: 4
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M686.705 553.296v-9.897 9.897z",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M686.705 553.296v-9.897",
    stroke: "#7c5f5f",
    strokeWidth: 4
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M655.913 553.296v-9.897 9.897z",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M655.913 553.296v-9.897",
    stroke: "#7c5f5f",
    strokeWidth: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.77ab608b2262eaba1206bc8eeee6fd8a.svg";
export { ForwardRef as ReactComponent };